import { render, staticRenderFns } from "./LimpiezaCleanerAgenda.vue?vue&type=template&id=2ee25b04"
import script from "./LimpiezaCleanerAgenda.vue?vue&type=script&lang=js"
export * from "./LimpiezaCleanerAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports